import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme, { colors: any }>((theme) => ({
  main: {
    width: '100%',
    minHeight: 181,
    display: 'flex',
    justifyContent: 'center',
    background: (props) => props.colors.colorGradient,
    padding: 10,
  },
  infos: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    color: '#fff',
  },
  infoTextTitle: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 700,
    marginBottom: 10,
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
  },
  infoTextSubTitle: {
    fontSize: theme.typography.pxToRem(14),
    lineHeight: '21px',
    fontWeight: 400,
    letterSpacing: '0.13px',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
  },
  img: {
    maxWidth: 414,
    [theme.breakpoints.down('md')]: {
      maxWidth: 'auto',
    },
  },
  boxFooter: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 48,
    alignItems: 'flex-start',
    gap: 20,
    // flexDirection={matchesMobile ? 'row' : 'column'}
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  socials: {
    marginTop: 10,
    marginLeft: -12,
    [theme.breakpoints.down('md')]: {
      display: 'flex',
    },
  },
  proderjBox: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'flex-start',
    flexShrink: 0,
    [theme.breakpoints.down('md')]: {
      padding: 20,
      marginLeft: 0,
      width: '100%',
      justifyContent: 'center',
    },
  },
  link: {
    textDecoration: 'none',
    color: '#fff',
    '&:hover': {
      color: (props) => props.colors.accentColor,
    },
  },
  logoBoxAndInfos: {
    display: 'flex',
    flexDirection: 'column',
    color: '#fff',
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
    },
  },
  navFooter: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
  },
  linkBox: {
    color: '#fff',
    marginRight: 40,
    paddingLeft: 52,
    display: 'inline-block',
    marginBottom: 24,
    minWidth: 200,
    flexBasis: 'calc(33.333% - 40px)',
    [theme.breakpoints.down('sm')]: {
      flexBasis: '100%',
      marginRight: 0,
    },
    '&:last-child': {
      marginRight: 0,
    },
    '& > p': {
      fontSize: 18,
      fontWeight: 700,
      lineHeight: '24px',
      letterSpacing: '0.17px',
      color: '#fff',
      marginTop: 0,
      marginBottom: 16,
    },
    '& ul': {
      listStyle: 'none',
      padding: 0,
      margin: 0,
      position: 'relative',
      '& li': {
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '21px',
        letterSpacing: '0.13px',
        marginBottom: 8,
        '& a': {
          color: '#fff',
          textDecoration: 'none',
          '&:hover': {
            color: (props) => props.colors.accentColor,
          },
        },
      },
    },
    '&:nth-child(-n+3) ul::before': {
      content: '""',
      position: 'absolute',
      left: -52,
      top: 0,
      height: '100%',
      width: 1,
      backgroundColor: '#fff',
    },
  },
}))
